import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'content-type-list',
};

const ContentTypeApi = createApi({
  reducerPath: 'content-type-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getContentTypes: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.contentType.list, body),
    }),
    createContentType: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.contentType.create,
        method: 'post',
        body: body,
      }),
    }),
    editContentType: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.contentType.edit,
        method: 'post',
        body: body,
      }),
    }),
    deleteContentType: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.contentType.delete,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const {
  useGetContentTypesQuery,
  useCreateContentTypeMutation,
  useEditContentTypeMutation,
  useDeleteContentTypeMutation,
} = ContentTypeApi;
export { ContentTypeApi };
